import React from "react";
import { getCurrentYear, getCurrentMonth } from "../../../../common/shared";
import { getLongestLivingClient } from "../utils";

const SelectMonth = ({
  value,
  onChange,
  year,
  error,
  planLength,
  owner,
  client,
  coClient,
  limitLength,
}) => {
  const currentYear = getCurrentYear();

  let offset = 1;
  let length = 12;

  // NOTE: We removed this code for some requirements issue with Expense and Incomes. However we still need
  // need the original behaviour for asset cards. The limitLength flag allows us to differentiate between the two
  // behaviours.
  if (
    parseInt(year) === currentYear + planLength - 1 &&
    owner !== null &&
    limitLength
  ) {
    const person = owner.id === client.id ? client : coClient;

    let birthMonth = parseInt(person.dateOfBirth.split("/")[0]);
    length = birthMonth - 1;
  }

  const months =
    length > 0
      ? Array.from(new Array(length), (val, index) => index + offset)
      : [12];

  const errorClass = error ? "validation-error month-select" : "month-select";

  return (
    <select className={errorClass} onChange={onChange}>
      {months.map((month, index) => (
        <option key={`month${index}`} value={month} selected={month === value}>
          {month.toString().padStart(2, "0")}
        </option>
      ))}
    </select>
  );
};

export default SelectMonth;
